module.exports = __webpack_public_path__ + "assets/35.jpg?ff1e7fe0a971dd193c49bdadbf7f913a";